import { render, staticRenderFns } from "./MatchFieldValues.vue?vue&type=template&id=60c95a08"
import script from "./MatchFieldValues.vue?vue&type=script&lang=js"
export * from "./MatchFieldValues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports